import React from 'react';

// eslint-disable-next-line react/prop-types
const Layers = ({ children }) => {
  return <div>{children}</div>;
};
export default Layers;
